<div class="container-fluid mt-2 display">
     <div class="row heading-row">
        <img class="ml-3 pb-3 submodule-svg" src="assets/icons/dashboard-icons/action-items.svg" />
        <div class="ml-2 heading pb-3">
            <!-- Please Fill the {{selectedIssue}}! -->
           Issue Details
        </div>
    </div>
    <div class="mt-3 form-container">
         <div class="example-radio-group-label">
            Please fill the details below to report a bug or suggest an improvement:
        </div>
        <form #bugForm="ngForm" (ngSubmit)="submitForm()" novalidate>
            <div class="row highlight">
                <label class="example-radio-group-label">1. You are reporting a:</label>
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                    [(ngModel)]="selectedIssue" name="issue" required #issueCtrl="ngModel">
                    <mat-radio-button *ngFor="let issue of issueArray" [value]="issue" class="example-radio-button">
                        {{ issue }}
                    </mat-radio-button>
                </mat-radio-group>
                <div *ngIf="issueCtrl.invalid && issueCtrl.touched" class="error-text">
                    Please select an issue.
                </div>
            </div>
            <div class="row mt-1 highlight">
                <div class="example-radio-group-label">
                    <mat-label>2. Enter the short summary of {{selectedIssue}}:</mat-label>
                </div>
                <div class="mt-4 ml-1 input-field short-summary">
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Short Summary</mat-label>
                        <input matInput [(ngModel)]="shortSummary" name="shortSummary"
                            (input)="enforceWordLimit('short', $event)" autocomplete="off"
                            style="text-transform: capitalize" required #shortInput
                            (keydown.enter)="descriptiveInput.focus()" #shortSummaryCtrl="ngModel" />
                    </mat-form-field>
                    <div class="text-muted">Words: {{ shortSummaryWordCount }} / 15</div>
                    <div *ngIf="(shortSummaryValidation && !shortSummary) || (shortSummaryCtrl.invalid && shortSummaryCtrl.touched)"
                        class="error-text">
                        Short summary is required.
                    </div>
                </div>
            </div>
            <div class="row mt-1 highlight">
                <div class="example-radio-group-label">
                    <mat-label>3. Enter detailed description of {{selectedIssue}}:</mat-label>
                </div>
                <div>
                    <div class="mt-4 ml-1 input-field descriptive-summary">
                        <mat-form-field appearance="outline" class="example-full-width custom-height-field">
                            <mat-label>Descriptive Summary</mat-label>
                            <textarea matInput [(ngModel)]="descriptiveSummary" name="descriptiveSummary"
                                (input)="enforceWordLimit('long', $event)" autocomplete="off" required
                                #descriptiveSummaryCtrl="ngModel" #descriptiveInput rows="4">
                        </textarea>
                        </mat-form-field>
                        <div class="text-muted">Words: {{ descriptiveSummaryWordCount }} / 500</div>
                        <div *ngIf="(descriptiveSummaryValidation && !descriptiveSummary) || (descriptiveSummaryCtrl.invalid && descriptiveSummaryCtrl.touched)"
                            class="error-text">
                            Descriptive summary is required.
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-1 highlight">
                <div class="example-radio-group-label">
                    <mat-label>4. Enter the Screenshot:</mat-label>
                </div>
                <div class="upload_img_maindiv">
                    <figure>
                        <div class="upload_img_cation_alignment">
                            <img class="upload_img" src="assets/images/blue_altair_logo.png" alt="" *ngIf="!photo" />
                            <label class="remove_img_text" *ngIf="this.imageError && !this.photo">{{ this.imageError
                                }}</label>
                            <button class="upload_text" type="button" *ngIf="!photo"
                                (click)="fileInput.click()">{{uploadImageTxt}}</button>
                            <input type="file" id="my_file" style="display: none" accept=".jpg,.png,.jpeg" multiple
                                [attr.max]="3" (change)="readMultipleFiles($event.target.files)" #fileInput />
                        </div>
                        <div class="image-preview-container">
                            <div class="image-preview" *ngFor="let img of photos; let i = index">
                                <ng-container *ngIf="img.fileType.startsWith('image')">
                                    <img [src]="img.fileUrl" alt="Uploaded Image {{i + 1}}">
                                </ng-container>
                                <button class="remove-btn" (click)="removeImage(i)"> <img
                                        src="assets/icons/dashboard-icons/close-pink-icon.svg"
                                        class="close-btn" /></button>
                            </div>
                        </div>
                        <figcaption class="remove_img_text" *ngIf="photos.length > 0" (click)="setDefaultImg()">
                            Remove File
                        </figcaption>
                    </figure>
                </div>
            </div>
            <div class="row mt-1 ml-1">
                <div class="left">
                    <button class="submit-butn blue-buttom">{{submitButton}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="loader-overlay" *ngIf="isLoading">
    <div class="loader-content">
        <div class="spinner"></div>
        <div class="loader-text">Reporting, please wait...</div>
    </div>
</div>
